import AddSubscriptionRequestModelBase from '../_generated/modelBases/add-subscription-request-model-base';

export default class AddSubscriptionRequestModel extends AddSubscriptionRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
